import { Version } from '@angular/core';

export const VERSION = new Version('19.2.0');
